export default __webpack_public_path__ + "static/media/2375.f213d6e3.png";